import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { IconButton, ListItemIcon } from '@mui/material';
import * as Icon from '@mui/icons-material/';
import { ListItem, ListItemButton, ListItemText } from '@mui/material/';
import { menus } from '../../routes/Menus';
import { AppBar, Drawer, DrawerHeader, StyledBox } from './DashboardStyle';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Login } from '../../routes/RoutesNames';
import { useEffect } from 'react';
import Version from '../../version.js'

export default function Dashboard() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = React.useState<boolean>(false);
  const [screen, setScreen] = React.useState<string>(location.pathname);
  const [openMenus, setOpenMenus] = React.useState<{ [key: number]: boolean }>(
    {}
  );

  const toggleSubMenu = (id: number) => {
    setOpen(true);
    setOpenMenus((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleDrawerOpen = (): void => {
    setOpen(true);
  };

  const handleDrawerClose = (): void => {
    setOpenMenus({});
    setOpen(false);
  };

  const refresh = (): void => {
    window.location.reload();
  };

  const handleMenuItemClick = (path: string): void => setScreen(path);

  const handleUnderlineMenuItemClick = (path: string): void => {
    if (path === 'Sair') {
      navigate(Login);
    }

    setScreen(path);
  };

  useEffect(() => {
    // Evita loop infinito verificando se já não está na rota
    if (location.pathname !== screen) {
      navigate(screen);
    }
  }, [screen]);

  // Este useEffect atualiza o MENU quando você navega por BOTÕES internos (Fechar, Salvar, etc)
  useEffect(() => {
    if (location.pathname !== screen) {
      setScreen(location.pathname);
    }
  }, [location]);

  return (
    <Box
      sx={{ 
        display: 'flex', 
        backgroundColor: '#F3F3F1',
        height: '100vh',
        overflow: 'hidden',
       }}
      style={{ width: '100vw' }}
    >
      <CssBaseline />
      <AppBar position='fixed'>
        <Toolbar>
          {/* <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            sx={{ marginRight: 5, ...(open && { display: 'none' }) }}
          >
            <Icon.Menu />
          </IconButton> */}
          <Typography variant='h5' noWrap component='div'>
            <div style={{ display: 'flex', paddingTop: '7px' }}>
              <img
                src='/images/promatec.png'
                style={{ cursor: 'pointer', paddingBottom: 8 }}
                onClick={refresh}
                width={100}
                alt='Promatec'
              ></img>
            </div>
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant='permanent'
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 300,
          height: '100vh',
          overflow:' hidden',
        }}
        open={open}
        onMouseEnter={() => handleDrawerOpen()}
        onMouseLeave={() => handleDrawerClose()}
        PaperProps={{
          className: 'custom-scrollbar',
          sx: {
            height: '100vh',
            position: 'absolute',
            display: 'flex',
            flexDirection: 'column', 
            justifyContent: 'space-between', 
            overflowY: 'hidden', 
          }
        }}
      >
        <DrawerHeader
          className={
            'flex justify-center align-middle items-center  w-full '
          }
        >
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? (
              <Icon.ChevronRight />
            ) : (
              <Icon.ChevronLeft style={{ color: '#F3F3F1' }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
            marginTop: 0,
          }}
        >
          <List>
            {menus.map((item) => (
              <React.Fragment key={item.id}>
                <ListItem disablePadding sx={{ display: 'block' }}>
                  <ListItemButton
                    onClick={() =>
                      item.subMenu
                        ? toggleSubMenu(item.id)
                        : handleMenuItemClick(item.screenRoute)
                    }
                    sx={{ minHeight: 48, justifyContent: open ? 'initial' : 'center', px: 2.5 }}
                    title={item.screenName}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                        color: '#F3F3F1',
                      }}
                    >
                      <item.icon />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.screenName}
                      primaryTypographyProps={{
                        fontWeight: 'bold',
                        color: '#F3F3F1',
                      }}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                    {open &&
                      item.subMenu &&
                      (openMenus[item.id] ? (
                        <Icon.ExpandLess style={{ color: '#F3F3F1' }} />
                      ) : (
                        <Icon.ExpandMore style={{ color: '#F3F3F1' }} />
                      ))}
                  </ListItemButton>
                </ListItem>
                {item.subMenu && openMenus[item.id] && (
                  <List sx={{ pl: 4 }}>
                    {item.subMenu.map((sub) => (
                      <ListItem key={sub.id} disablePadding>
                        <ListItemButton
                          onClick={() => handleMenuItemClick(sub.screenRoute)}
                          sx={{
                            minHeight: 48,
                            justifyContent: 'center',
                            px: 2.5,
                          }}
                        >
                          <ListItemText
                            primary={sub.screenName}
                            primaryTypographyProps={{
                              fontWeight: 'bold',
                              color: '#F3F3F1',
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                )}
              </React.Fragment>
            ))}
          </List>
          {open && (
            <div style={{ flexGrow: 1, display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
              <span style={{ fontFamily: 'monospace', color: '#BBB', fontSize: '14px', padding: '8px' }}>v.{Version?.vApp}</span>
            </div>
          )}
        </Box>
        <Divider />
        <List className={''}>
          {[/*'Quem somos',*/ 'Sair'].map((text/*, index*/) => (
            <ListItem key={text} disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                onClick={() => handleUnderlineMenuItemClick(text)}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
                title={text}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                    color: '#F3F3F1',
                  }}
                >
                  {/* {index % 2 === 0 ? <Icon.HomeWork /> : <Icon.Logout />} */}
                  <Icon.Logout />
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{
                    fontWeight: 'bold',
                    color: '#F3F3F1',
                  }}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

      </Drawer>
      <StyledBox>
        <Outlet />
      </StyledBox>
    </Box>
  );
}
